import React from 'react';

import {
  Input,
  InputProps,
} from '@ast/magma/components/input';

export const MEMO_MAX_LENGTH = 240;

export type MemoFieldProps = InputProps
& React.InputHTMLAttributes<HTMLInputElement>
& React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export type MemoFieldRef = HTMLInputElement & HTMLTextAreaElement;

export const MemoField = React.forwardRef((
  props: MemoFieldProps,
  ref: React.Ref<MemoFieldRef>,
) => (
  <Input
    data-stable-name="MemoInput"
    multiline
    {...props}
    ref={ref}
  />
));
